import React from 'react';
import { CameraIcon, PlusIcon } from '../icons';
import './PhotoGallery.css';

export interface PhotoActionBarProps {
  /** Callback when the bar is clicked */
  onClick?: () => void;
  /** Placeholder text (default: "Share a photo...") */
  placeholder?: string;
  /** Optional className */
  className?: string;
}

/**
 * PhotoActionBar – A tappable bar styled like an input field.
 * Links to the add-photo flow (not an actual input).
 */
export const PhotoActionBar: React.FC<PhotoActionBarProps> = ({
  onClick,
  placeholder = 'Share a photo...',
  className,
}) => {
  return (
    <button
      type="button"
      className={`photo-action-bar ${className || ''}`}
      onClick={onClick}
    >
      <span className="photo-action-bar__placeholder">{placeholder}</span>
      <div className="photo-action-bar__actions">
        <span className="photo-action-bar__icon">
          <CameraIcon size="s" tone="lightGrey" />
        </span>
        <span className="photo-action-bar__plus">
          <PlusIcon size="xs" tone="lightGrey" style={{ width: 18, height: 18 }} />
        </span>
      </div>
    </button>
  );
};

export default PhotoActionBar;
